import { apiClient } from './client';
import { API_ENDPOINTS } from './config';

export enum PlanType {
  FREE = 'free',
  PRO = 'pro',
}

export interface PlanResponse {
  id: string;
  name: string;
  type: PlanType;
  priceInCents: number;
  currency: string;
  interval?: string;
  description?: string;
  creditsIncluded: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UserPlanResponse {
  plan: PlanResponse | null;
  type: PlanType;
  isActive: boolean;
  expiresAt: string | null;
}

export interface AssignPlanRequest {
  planId: string;
  stripeSubscriptionId?: string;
  stripeCustomerId?: string;
  expiresAt?: string;
}

export const plansApi = {
  async getAll(): Promise<PlanResponse[]> {
    return apiClient.get<PlanResponse[]>(API_ENDPOINTS.PLANS.BASE);
  },

  async getMyPlan(): Promise<UserPlanResponse> {
    return apiClient.get<UserPlanResponse>(API_ENDPOINTS.PLANS.ME);
  },

  async getById(id: string): Promise<PlanResponse> {
    return apiClient.get<PlanResponse>(API_ENDPOINTS.PLANS.BY_ID(id));
  },

  async assignPlan(data: AssignPlanRequest): Promise<UserPlanResponse> {
    return apiClient.post<UserPlanResponse>(API_ENDPOINTS.PLANS.ASSIGN, data);
  },
};
